import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ValueProposition = () => {
  const navigate = useNavigate();

  const services = [
    {
      icon: 'Lightbulb',
      title: 'ICT Consultancy',
      description: 'Strategic technology planning and digital transformation guidance'
    },
    {
      icon: 'Server',
      title: 'Infrastructure Solutions',
      description: 'Robust IT infrastructure design, implementation, and management'
    },
    {
      icon: 'Network',
      title: 'Networking Services',
      description: 'Enterprise networking, security, and connectivity solutions'
    },
    {
      icon: 'Code',
      title: 'Software Development',
      description: 'Custom software solutions tailored to your business needs'
    },
    {
      icon: 'FileText',
      title: 'Policy & Strategy',
      description: 'IT governance, compliance, and strategic policy development'
    },
    {
      icon: 'Puzzle',
      title: 'System Integration',
      description: 'Seamless integration of diverse technology systems'
    }
  ];

  const benefits = [
    {
      icon: 'Clock',
      title: 'Quick Quotations',
      description: 'Get detailed quotes within 24 hours through our RFQ system'
    },
    {
      icon: 'Shield',
      title: 'Secure Transactions',
      description: 'SSL-encrypted payments with mobile money integration'
    },
    {
      icon: 'Users',
      title: 'Expert Team',
      description: 'Certified professionals with 10+ years of experience'
    },
    {
      icon: 'Headphones',
      title: '24/7 Support',
      description: 'Round-the-clock technical support and customer service'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Main Value Proposition */}
      <div className="text-center bg-gradient-to-br from-primary/5 to-accent/5 rounded-lg p-8 border border-border">
        <div className="flex items-center justify-center w-20 h-20 bg-primary rounded-full mx-auto mb-6">
          <Icon name="Zap" size={40} color="white" />
        </div>
        
        <h2 className="text-3xl font-bold text-foreground mb-4">
          Innovate, Connect, Transform
        </h2>
        
        <p className="text-lg text-muted-foreground mb-6 max-w-md mx-auto">
          Your trusted partner for comprehensive ICT solutions in Uganda. 
          Join hundreds of businesses transforming their digital future.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            variant="default"
            iconName="ArrowRight"
            iconPosition="right"
            onClick={() => navigate('/product-catalog')}
          >
            Explore Solutions
          </Button>
          
          <Button
            variant="outline"
            iconName="FileText"
            iconPosition="left"
            onClick={() => navigate('/rfq-request-form')}
          >
            Request Quote
          </Button>
        </div>
      </div>
      {/* Services Overview */}
      <div className="bg-card rounded-lg p-6 border border-border shadow-subtle">
        <h3 className="text-xl font-semibold text-foreground mb-6 text-center">
          Our ICT Solutions
        </h3>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {services?.map((service, index) => (
            <div key={index} className="p-4 bg-muted/30 rounded-lg hover:bg-muted/50 transition-smooth">
              <div className="flex items-center space-x-3 mb-2">
                <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name={service?.icon} size={16} className="text-primary" />
                </div>
                <h4 className="font-medium text-foreground text-sm">{service?.title}</h4>
              </div>
              <p className="text-xs text-muted-foreground">{service?.description}</p>
            </div>
          ))}
        </div>
      </div>
      {/* Key Benefits */}
      <div className="bg-card rounded-lg p-6 border border-border shadow-subtle">
        <h3 className="text-xl font-semibold text-foreground mb-6 text-center">
          Why Businesses Choose Us
        </h3>
        
        <div className="space-y-4">
          {benefits?.map((benefit, index) => (
            <div key={index} className="flex items-start space-x-4 p-3 rounded-lg hover:bg-muted/30 transition-smooth">
              <div className="flex-shrink-0 w-10 h-10 bg-success/10 rounded-full flex items-center justify-center">
                <Icon name={benefit?.icon} size={18} className="text-success" />
              </div>
              <div>
                <h4 className="font-medium text-foreground mb-1">{benefit?.title}</h4>
                <p className="text-sm text-muted-foreground">{benefit?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Call to Action */}
      <div className="bg-primary/5 rounded-lg p-6 border border-primary/20 text-center">
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Ready to Get Started?
        </h3>
        <p className="text-sm text-muted-foreground mb-4">
          Create your account today and access our full range of ICT solutions
        </p>
        <Button
          variant="default"
          iconName="UserPlus"
          iconPosition="left"
          onClick={() => navigate('/register')}
        >
          Create Free Account
        </Button>
      </div>
    </div>
  );
};

export default ValueProposition;